if ($('.banner-slider').length) {
  $(".banner-slider .banner-wrapper").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
  });
}

if ($('.brand-text').length) {
  $(document).ready(function() {
    var $brandText = $('.brand-text');
    var maxHeight = 70;

    if ($brandText.outerHeight() > maxHeight) {
      $brandText.addClass('collapsed');
      var $toggleBtn = $('<div class="btn-wrap text-center"><button class="btn btn-secondary" id="toggle-btn">Zobrazit více</button></div>');
      $toggleBtn.insertAfter($brandText);
      var $toggleClick = $($toggleBtn).find('#toggle-btn'); 

      $toggleClick.on('click', function() {
        if ($brandText.hasClass('collapsed')) {
          $brandText.removeClass('collapsed');
          $brandText.addClass('show-text');
          $toggleClick.text('Zobrazit méně');
        } else {
          $brandText.addClass('collapsed');
          $brandText.removeClass('show-text');
          $toggleClick.text('Zobrazit více');
        }
      });
    }
  });
}

if ($('.pkVPImgs').length) {
  $(document).ready(function() {
    $(".pkVPImgs").each(function() {
      var container = $(this);
      var items = container.find(".item-img");
      var button = container.find("#toggleImages");
  
      items.slice(6).hide();
  
      button.click(function() {
        if (container.hasClass("showAll")) {
          items.slice(6).hide();
          container.removeClass("showAll");
        } else {
          items.show();
          container.addClass("showAll");
        }
      });
    });
  })
}


if($('#pkVPImgs').length){
  $('#pkVPImgs .item-img img').each(function(){
      var $this = $(this);
      $this.colorbox({
          rel: 'gallery',
          href: $this.attr('src'),
          title: $this.attr('alt'),
          maxWidth: '95%',
          maxHeight: '95%',
          photo: true,
          current: "{current} z {total}",
          className: "customImageColorbox"
          //slideshow: true,
         // slideshowSpeed: 5000,

      });
  });
}